import { Routes } from '@angular/router';
import { ShiveRoutes } from '../segments/route-segments';
import { UrlSegmentDelimiter } from '../../constants-repository/app-style.constants';
import { AbsencePlannerComponent } from '../../../pages/team/absences/absence-planner/absence-planner.component';
import { AbsencesComponent } from '../../../pages/team/absences/absences.component';
import { VacationQuotaComponent } from '../../../pages/team/absences/vacation-insights/vacation-quota.component';
import { LeaveRequestsComponent } from '../../../pages/team/absences/leave-requests/leave-requests.component';
import { ManageProjectComponent } from '../../../pages/project/project-details/project-edit/manage-project/manage-project.component';
import { TeamListComponent } from '../../../pages/team/team-list/team-list.component';
import { UserProfileComponent } from '../../../pages/user/user-profile/user-profile.component';
import { UserProfileRoutes } from './user-profile.routes';
import { userResolver } from '../../resolver/user/user.resolver';

export const TeamRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ShiveRoutes.Overview,
  },
  {
    path: ShiveRoutes.Overview,
    component: TeamListComponent,
  },
  {
    path: ShiveRoutes.Create,
    component: ManageProjectComponent,
  },
  {
    path: `${ShiveRoutes.UserEdit + UrlSegmentDelimiter}:id`,
    component: UserProfileComponent,
    children: UserProfileRoutes,
    resolve: {
      user: userResolver,
    },
  },
  {
    path: ShiveRoutes.Absences,
    component: AbsencesComponent,
    children: [
      {
        path: `${ShiveRoutes.Planner}`,
        component: AbsencePlannerComponent,
      },
      {
        path: `${ShiveRoutes.VacationQuota}`,
        component: VacationQuotaComponent,
      },
      {
        path: `${ShiveRoutes.LeaveRequests}`,
        component: LeaveRequestsComponent,
      },
    ],
  },
];
